import React from "react";
import Top_bar from "../../Components/topBar/topBar";
import AddMachine from "../Registration/Machine/addMachine";
import AltMachine from "../Registration/Machine/altMachine";
import DelMachine from "../Registration/Machine/delMachine";
import { Tab, Row, Col, ListGroup } from "react-bootstrap";
import TableList from "../../Components/tableList/TableList";
import Alert from "../../Components/alert/Alert";
import Api from "../../services/api";
import "./prelude.css";
import "../../Components/reports/reports.css";
import MessageTable from "../../Components/messageTable/MessageTable";
import BottomBar from "../../Components/bottomBar/bottomBar";
import {handleColor} from '../../services/Functions'
import ReportMachines from "../Reports/reportMachines";

class prelude_machine extends React.Component {
  render() {
    return (
      <>
        <header>
          <Top_bar />{" "}
        </header>
        <div className="prelude_container">
          <Sidebar></Sidebar>
        </div>
        <BottomBar></BottomBar>
      </>
    );
  }
}

class Sidebar extends React.Component {
  state = { data: [], keys: [], render: false, message: "", click: false };

  async componentDidMount() {
    let array = [];
    await Api.get("/machines")
      .then((response) => {
        response.data.forEach(({description,code,factory,department}) => {
          array.push({
            Máquina: description+code,
            ["Planta"]:factory.factory_name,
            Setor:department,
          });
        });
        if (array.length > 0) this.setState({ data: array, render: true });
      })
      .catch((err) => {
        this.setState({ message: "" });
      });
     
  }

  handleClick = () => {
    if (this.props.click === false) {
      this.setState({ click: true });
      return true;
    } else {
      this.setState({ click: false });
      return false;
    }
  };

  
  render() {
    const { show, message } = this.state;
    return (
      <Tab.Container defaultActiveKey="list">
        <Row style={{width:'100%',height:'100%'}}>
          <div className="sidebar1">
            <div className="sidebar2">
              <Col className="sidebarColumn">
                <ListGroup>
                  <ListGroup.Item 
                    id='lg1'
                    onClick={handleColor}
                    style={{backgroundColor:'#05ca83',color:'#fff',border:'none'}}
                    className='listGroup' eventKey="list">Máquinas</ListGroup.Item>
                  <ListGroup.Item
                    id='lg2'
                    onClick={handleColor}
                    className='listGroup'
                    action
                    eventKey="add"
                  >
                    Adicionar Máquina
                  </ListGroup.Item>
                  <ListGroup.Item
                    id='lg3'
                    onClick={handleColor}
                    className='listGroup'
                    action
                    eventKey="alt"
                  >
                    Alterar Máquina
                  </ListGroup.Item>
                  <ListGroup.Item 
                    id='lg4'
                    onClick={handleColor}
                    className='listGroup' action eventKey="del">
                    Deletar Máquina
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </div>
            <Col className='col3' style={{ top: "5%", marginLeft: "1.5%", width: "100%",height:'78vh', overflow:'auto' }}>
              {show ? (
                <Alert
                  show={show}
                  message={message}
                  parentCallback={this.callbackfunction}
                />
              ) : null}
              <Tab.Content>
                <Tab.Pane eventKey="list">
                  {this.handleClick ? <ReportMachines /> : null}
                </Tab.Pane>
                <Tab.Pane mountOnEnter unmountOnExit eventKey="add">
                  {this.handleClick ? <AddMachine /> : null}
                </Tab.Pane>
                <Tab.Pane mountOnEnter unmountOnExit eventKey="alt">
                  {this.handleClick ? <AltMachine /> : null}
                </Tab.Pane>
                <Tab.Pane mountOnEnter unmountOnExit eventKey="del">
                  {this.handleClick?<DelMachine/>:null}
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </div>
        </Row>
      </Tab.Container>
    );
  }
}

export default prelude_machine;